export default "__VITE_ASSET__CyX0Njt1__"